var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.TourPageHeader,{attrs:{"user":_vm.authData.user,"account-url":_vm.authData.accountUrl,"tour":_setup.tour},on:{"login":function($event){return _vm.$emit('login')},"logout":function($event){return _vm.$emit('logout')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }